const prefix = "user";
const pprefix = "participant";

export const SET_USER = `${prefix}/SET_USER`;
export const SET_PARTICIPANT = `${pprefix}/SET_PARTICIPANT`;
export const SET_USER_TOKENS = `${prefix}/SET_USER_TOKENS`;
export const SET_PARTICIPANT_TOKENS = `${pprefix}/SET_PARTICIPANT_TOKENS`;
export const LOGOUT_USER = `${prefix}/LOGOUT_USER`;
export const LOGOUT_PARTICIPANT = `${pprefix}/LOGOUT_PARTICIPANT`;
export const SESSION_EXPIRED = `${pprefix}/SESSION_EXPIRED`;
export const SET_AWS_ACCESS_TOKENS = `${prefix}/SET_AWS_ACCESS_TOKENS`;
export const SHOW_LOADER = `SHOW_LOADER`;
export const SET_PARTICIPANT_AWS_ACCESS_TOKEN = `${prefix}/SET_PARTICIPANT_AWS_ACCESS_TOKEN`;
export const SAVE_PARTICIPANT_DATA = `${prefix}/SAVE_PARTICIPANT_DATA`;
export const SAVE_PARTICIPANT_STUDY_START_STATUS = `${prefix}/SAVE_PARTICIPANT_STUDY_START_STATUS`;
